import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "centerContainer" }
const _hoisted_2 = { class: "formKitWrap" }
const _hoisted_3 = { class: "formKit" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("もう一度ご確認ください。")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("すでにアカウントがあります")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, "新規登録", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "@vets-index.com からのメールを許可してください。", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "英語と数字を含めて8文字以上です。記号は^$*.[]{}()?\"!@#%&/\\,<>':|_~`が利用できます。", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("同意する")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.google.com/document/d/e/2PACX-1vRXLldYTxMRWYVBUdnM1vOs5Cjaag7XidFhFdyFM7Cqu6xrfJBfd2yNqzIw8oTPb5T17SQq5MzUB2TF/pub",
  target: "_blank"
}, "利用規約/プライバシーポリシー", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"1rem"} }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("登録する")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "center" }, "メールの確認", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("」宛に確認リンクを送信しました。確認リンクから登録を続行してください。 ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "このページは閉じてください。", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "note" }, "メールが見つかりませんか？迷惑メールフォルダなどに振り分けられている可能性があります。", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_VueRecaptcha = _resolveComponent("VueRecaptcha")!
  const _component_n_collapse_transition = _resolveComponent("n-collapse-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.err)
          ? (_openBlock(), _createBlock(_component_n_alert, {
              key: 0,
              title: "失敗しました",
              type: "error",
              closable: "",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.err), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.resendDone)
          ? (_openBlock(), _createBlock(_component_n_alert, {
              key: 1,
              title: "再送信しました",
              type: "info",
              closable: "",
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_n_collapse_transition, {
          show: _ctx.mode === 'signup'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_space, {
              justify: "center",
              style: {"padding-top":"1rem"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, {
                  type: "info",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/hospital/login')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_n_divider),
            _hoisted_6,
            _createVNode(_component_n_form, {
              model: _ctx.model,
              ref: "formRef",
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_form_item, {
                  path: "email",
                  label: "メールアドレス"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_component_n_input, {
                      value: _ctx.model.email,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.email) = $event)),
                      placeholder: " ",
                      "input-props": { autocomplete: 'email' }
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "pwd",
                  label: "パスワード"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_n_input, {
                      value: _ctx.model.pwd,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.pwd) = $event)),
                      type: "password",
                      "show-password-on": "click",
                      placeholder: " ",
                      "input-props": { autocomplete: 'new-password' }
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "rePwd",
                  label: "パスワード再入力"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.model.rePwd,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.rePwd) = $event)),
                      type: "password",
                      "show-password-on": "click",
                      placeholder: " ",
                      "input-props": { autocomplete: 'new-password' }
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  path: "agree",
                  label: "利用規約"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_checkbox, {
                      checked: _ctx.model.agree,
                      "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.agree) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createVNode(_component_VueRecaptcha, {
              ref: "recaptcha",
              sitekey: "6LceWFEeAAAAAFABNabeWhOL1DcHk_U3A7ksHLIE",
              onVerify: _ctx.onVerify,
              onExpired: _ctx.recaptchaExpired
            }, null, 8, ["onVerify", "onExpired"]),
            _hoisted_11,
            _createVNode(_component_n_space, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, {
                  type: "primary",
                  onClick: _ctx.post,
                  loading: _ctx.loading,
                  disabled: !_ctx.model.agree || !_ctx.recaptcha
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_n_collapse_transition, {
          show: _ctx.mode === 'verify'
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createElementVNode("p", null, [
              _createTextVNode(" 入力されたメールアドレス「" + _toDisplayString(_ctx.model.email) + " ", 1),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mode = 'signup'))
              }, "メールアドレスを変更"),
              _hoisted_14
            ]),
            _hoisted_15,
            _hoisted_16
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ])
  ]))
}